import { useEffect } from "react";
import { usePipecatConnectionState } from "@pipecat-ai/voice-ui-kit";
import { Controls } from "@/components/Controls";
import { Header } from "@/components/Header";
import { OfficialStatementPanel } from "@/components/OfficialStatementPanel";
import { PhoneCall } from "@/components/PhoneCall";
import {
    clearOfficialStatement,
    useOfficialStatement,
} from "@/components/official-statement-store";

const REPORT_EXIT_DURATION_MS = 720;

export function VoiceAssistant() {
    const { statement } = useOfficialStatement();
    const { isConnected, isConnecting } = usePipecatConnectionState();
    const isReportVisible = Boolean(statement) && (isConnected || isConnecting);

    useEffect(
        function unmountReportAfterExit() {
            if (isReportVisible || !statement) {
                return;
            }
            const timer = window.setTimeout(
                clearOfficialStatement,
                REPORT_EXIT_DURATION_MS,
            );
            return function cleanup() {
                window.clearTimeout(timer);
            };
        },
        [isReportVisible, statement],
    );

    return (
        <div className="flex h-dvh w-full flex-col overflow-hidden bg-gradient-to-b from-zinc-50 via-white to-zinc-100 text-zinc-700">
            <Header />
            <main
                className="investigator-layout min-h-0 flex-1"
                data-report={isReportVisible ? "true" : "false"}
            >
                <div className="flex min-w-0 flex-1 flex-col">
                    <PhoneCall />
                    <Controls />
                </div>
                <OfficialStatementPanel />
            </main>
        </div>
    );
}
